import styled, { css } from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { ModalSheet } from '@/components/UI/ModalSheet';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Body as BottomSheetBody } from '@/components/UI/BottomSheet/BottomSheet.styles';

export const Sheet = styled(ModalSheet)`
  ${BottomSheetBody} {
    padding: 0;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 5px;
  }
`;

export const PackageCard = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 21px;
  background-color: ${({ theme }) => theme.palette.primary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 5px;
  }
`;

export const PackageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 25px;
  gap: 10px;
`;

export const NameBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Name = styled(Typography.Body)`
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const BenefitBadge = styled.span`
  padding: 5px 10px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.palette.system.blue};
  color: ${({ theme }) => theme.palette.system.white};
  font-size: 13px;
  line-height: 16px;
  white-space: nowrap;
`;

export const CompactBenefitBadge = styled.span`
  display: inline-flex;
  flex: 0 0 18px;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.system.blue};
`;

export const AdditionalDiscountBadge = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  padding: 8px 12px 9px;
  border-radius: 0 0 0 14px;
  background-color: #f39d16;
  color: ${({ theme }) => theme.palette.system.white};
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
`;

export const PriceBox = styled.div<{ $hasOriginalPrice: boolean }>`
  display: flex;
  flex-direction: column;
  margin-top: ${({ $hasOriginalPrice }) => ($hasOriginalPrice ? 0 : '17px')};
  margin-bottom: 19px;
`;

export const OriginalPrice = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
  font-size: 15px;
  font-weight: 700;
  text-decoration: line-through;
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 5px;
`;

export const Price = styled(Typography.Numbers)`
  font-size: 32px;
  font-weight: 700;
`;

export const Period = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
  font-size: 14px;
`;

export const Features = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 0;
  list-style: none;
`;

export const Feature = styled.li`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 0;
  font-size: 14px;

  svg {
    flex: 0 0 11px;
  }
`;

export const ActivationCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  border-radius: 21px;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const ActivationTitle = styled(Typography.Body)`
  font-size: 16px;
  font-weight: 500;
`;

export const DateOptions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const DateOption = styled(Button).attrs({
  borderRadius: 100,
})<{ $isActive: boolean }>`
  height: 40px;
  padding: 8px 14px;
  border: 1px solid
    ${({ $isActive, theme }) =>
      $isActive ? theme.palette.system.blue : 'transparent'};
  background-color: ${({ theme }) => theme.palette.secondary.background};
  color: ${({ $isActive, theme }) =>
    $isActive ? theme.palette.system.blue : theme.palette.primary.labels};
  font-size: 15px;

  ${({ $isActive, theme }) =>
    !$isActive &&
    css`
      @media (hover: hover) {
        &:hover {
          background-color: ${theme.palette.secondary.border};
        }
      }
    `}
`;

export const ContinueButton = styled(Button).attrs({
  appearance: 'secondary',
  borderRadius: 14,
  isFullWidth: true,
})`
  height: 50px;
`;

export const ActionButtonSection = styled.div`
  margin-top: 5px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 0;
    padding: 10px 15px 20px;
    border-radius: 14px 14px 0 0;
    background-color: ${({ theme }) => theme.palette.primary.background};
  }
`;
